const AssetsList = () => import('../../views/platform/AssetsList.vue');
const AssetsEdit = () => import('../../views/platform/AssetsEdit.vue');
const CustomerServiceList = () => import('../../views/platform/CustomerServiceList.vue');
const CustomerServiceEdit = () => import('../../views/platform/CustomerServiceEdit.vue');

const Container = {
  template: `
    <div class="Container">
      <router-view></router-view>
    </div>
  `,
};

const router = {
  path: '/platform/productList',
  name: 'PlatformContainer',
  component: Container,
  meta: {
    title: '平台管理',
    icon: 'set-up',
  },
  children: [
    {
      path: '/platform/assetsList',
      name: 'AssetsContainer',
      component: Container,
      meta: {
        title: '静态资源管理',
        hideChildren: true,
      },
      children: [
        {
          path: '',
          name: 'AssetsList',
          component: AssetsList,
          meta: {
            title: '静态资源列表',
          },
        },
        {
          path: '/platform/assetsEdit/:assetsCode',
          name: 'AssetsEdit',
          component: AssetsEdit,
          meta: {
            title: '静态资源编辑',
            light: '/platform/assetsList',
          },
        },
      ],
    },
    {
      path: '/platform/customerServiceList',
      name: 'CustomerServiceContainer',
      component: Container,
      meta: {
        title: '客服管理',
        hideChildren: true,
      },
      children: [
        {
          path: '',
          name: 'CustomerServiceList',
          component: CustomerServiceList,
          meta: {
            title: '客服列表',
          },
        },
        {
          path: '/platform/customerServiceEdit/:customerServiceId',
          name: 'CustomerServiceEdit',
          component: CustomerServiceEdit,
          meta: {
            title: '客服编辑',
            light: '/platform/customerServiceEdit',
          },
        },
      ],
    },
  ],
};
export default router;



// WEBPACK FOOTER //
// ./src/router/modules/platform.js